
import Service from './Service';

class UserTerms extends Service {

    acceptTerms({ termID }) {
        return this.axiosInstance.post(`/user-terms`, { termID });
    }

    checkUserTerms(readonly) {
        return this.axiosInstance.get(`/user-terms?readOnly=${readonly ? true : false}`);
    }

}

export default UserTerms;